(() => {
  'use strict';

  // Use Empire's existing close action, including its animation and focus return.
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ho-atc-dismiss]');
    if (!button) return;
    event.preventDefault();
    button.closest('[data-atc-banner]')?.querySelector('[data-atc-banner-close]')?.click();
  });
})();
